/* =================== CONTADORES ANIMADOS (VANILLA JS) =================== */
(function () {
  "use strict";

  document.addEventListener("DOMContentLoaded", function () {
    const counters = document.querySelectorAll(".contador-num");
    if (counters.length === 0) return;

    // Função de animação de cada contador individual
    function animateCounter(counter) {
      const target = parseInt(counter.getAttribute("data-count"), 10) || 0;
      const duration = 2000; // Tempo de animação em ms
      let startTime = null;

      // Formatador brasileiro (ex: 420.000)
      const formatter = new Intl.NumberFormat("pt-BR");

      function step(currentTime) {
        if (!startTime) startTime = currentTime;
        const progress = Math.min((currentTime - startTime) / duration, 1);
        
        // Easing suave (easeOutCubic)
        const easeProgress = 1 - Math.pow(1 - progress, 3);
        
        const currentValue = Math.floor(easeProgress * target);
        counter.textContent = formatter.format(currentValue);

        if (progress < 1) {
          requestAnimationFrame(step);
        } else {
          counter.textContent = formatter.format(target);
        }
      }

      requestAnimationFrame(step);
    }

    // IntersectionObserver para disparar somente ao entrar na viewport
    const observerOptions = {
      root: null,
      threshold: 0.1, // Dispara com 10% do elemento visível
    };

    const observer = new IntersectionObserver((entries, observerInstance) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const counter = entry.target;
          animateCounter(counter);
          // Para de observar este item para rodar a animação apenas uma vez
          observerInstance.unobserve(counter);
        }
      });
    }, observerOptions);

    // Registra os contadores no observador
    counters.forEach((counter) => observer.observe(counter));
  });
})();
